import { faMapSalesforce } from '@awesome.me/kit-09b03e5df4/icons/kit/custom';
import { faLayerGroup as faLayerGroupDuo } from '@fortawesome/pro-duotone-svg-icons/faLayerGroup';
import { faImages } from '@fortawesome/pro-regular-svg-icons/faImages';
import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons/faLayerGroup';
import { faMap } from '@fortawesome/pro-regular-svg-icons/faMap';
import { faPencilSlash } from '@fortawesome/pro-solid-svg-icons';
import type { MapListingRowItem } from '~/map/listing/tableData/mapRow/mapRow.component';

export const getMapRowIcon = ({ isSnapshot, item }: { isSnapshot: boolean; item: MapListingRowItem }) => {
  const isConnected = !!item.layering?.connected;
  const isSalesforce = item.source === 'salesforce';
  const isReadOnly = !!item.isReadOnly;

  if (isSnapshot) {
    return faImages;
  }

  if (item.isBaseLayer) {
    return faLayerGroupDuo;
  }

  if (isSalesforce) {
    return faMapSalesforce;
  }
  if (isReadOnly) {
    return faPencilSlash;
  }

  return isConnected ? faLayerGroup : faMap;
};
